// src/components/StatsCards.js
import React from "react";
import { AlertCircle, CheckCircle, Zap, Bot } from "lucide-react";

function StatsCards({ stats }) {
  const cards = [
    {
      title: "Total Errors",
      value: stats.total || 0,
      icon: AlertCircle,
      color: "from-red-500 to-red-600",
      bg: "bg-red-500/10",
      border: "border-red-500/20",
      glow: "shadow-red-500/10",
    },
    {
      title: "AI Analyzed",
      value: stats.analyzed || 0,
      icon: Bot,
      color: "from-cyan-500 to-blue-600",
      bg: "bg-cyan-500/10",
      border: "border-cyan-400/20",
      glow: "shadow-cyan-500/10",
    },
    {
      title: "Fixed",
      value: stats.fixed || 0,
      icon: CheckCircle,
      color: "from-green-500 to-green-600",
      bg: "bg-green-500/10",
      border: "border-green-500/20",
      glow: "shadow-green-500/10",
    },
    {
      title: "Avg Confidence",
      value: `${stats.avgConfidence || 0}%`,
      icon: Zap,
      color: "from-yellow-500 to-yellow-600",
      bg: "bg-yellow-500/10",
      border: "border-yellow-500/20",
      glow: "shadow-yellow-500/10",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {cards.map((card) => {
        const Icon = card.icon;
        return (
          <div
            key={card.title}
            className={`group bg-gradient-to-br from-gray-900/80 to-gray-950/80 backdrop-blur-sm border ${card.border} rounded-xl p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl ${card.glow}`}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-400">{card.title}</p>
                <p className="text-2xl font-bold text-white mt-1 group-hover:text-cyan-400 transition-colors duration-300">
                  {card.value}
                </p>
              </div>
              <div
                className={`p-3 rounded-xl bg-gradient-to-br ${card.color} shadow-lg ${card.glow}`}
              >
                <Icon className="w-6 h-6 text-white" />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default StatsCards;
